module.exports = __webpack_public_path__ + "img/zu2.6e34df64.png";